
import RewardTriggerResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Reward/RewardTriggerResponse";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
@Component
export default class UiRewardTriggerDropdown extends Vue {
  @Prop() value: number;
  @Prop({ default: false, type: Boolean }) required: boolean;
  @Prop({
    default: () =>
      new RewardTriggerResponse({
        Trigger: null,
        Name: "Выберите тип",
      }),
    type: RewardTriggerResponse,
  })
  noTrigger: boolean;

  @Watch("value")
  valueUpdate(newValue: number) {
    this.innerValue = newValue;
  }

  @Watch("innerValue")
  innerValueUpdate(newValue: string) {
    this.$emit("input", newValue);
  }

  innerValue: number = 0;
  triggers: RewardTriggerResponse[] = [];

  async created() {
    this.innerValue = this.value;
    try {
      this.triggers = await this.$api.RewardService.getRewardTriggersAsync();
    } catch (error) {
      this.triggers = [];
      if ((error || {}).StatusCode !== 401) {
        this.$notification.error(error);
      }
    }
  }
}
